import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { IngredientChoice, IngredientChoiceGroup, IngredientChoicesType, OrderableItem, OrderedItem } from 'ngx-web-api';
import { EditingItemChoicesService } from '../../core/services/editing-item-choices.service';
import { ViewportService } from 'app/core/services/viewport.service';
import { CanMoveToStepChoicePipe } from '../pipes/can-move-to-step-choice.pipe';
import { CanMoveToStepGroupPipe } from '../pipes/can-move-to-step-group.pipe';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fts-item-editor-modal-header',
  templateUrl: './item-editor-modal-header.component.html',
  styleUrls: ['./item-editor-modal-header.component.scss'],
})
export class ItemEditorModalHeaderComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input()
  isMobile: boolean;
  @Input()
  inItemEditorModal = false;
  @Input()
  ingredientChoicesType: IngredientChoicesType;
  @Input()
  trackByChoiceFn: any;
  @Input()
  choices: IngredientChoice[] = [];
  @Input()
  visibleChoice?: IngredientChoice;
  @Input()
  item: OrderedItem;
  @Input()
  orderableItem: OrderableItem;
  @Input()
  filteredGroups: IngredientChoiceGroup[];
  @Input()
  trackByChoiceGroupFn: any;
  @Input()
  selectedChoiceGroup: IngredientChoiceGroup;
  @Input()
  choiceGroups: IngredientChoiceGroup[];
  @Input()
  selectedChoice: IngredientChoice;

  @Output()
  choiceGroupChange = new EventEmitter<IngredientChoiceGroup>();
  @Output()
  onSelectChoice = new EventEmitter<IngredientChoice>();
  @Output()
  loadComponent = new EventEmitter<{ scrollLinksWrapper: ElementRef; scrollLinks: ElementRef }>();
  @Output()
  cancelBtnClick: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('scrollLinksWrapper', { static: false })
  private scrollLinksWrapper: ElementRef;

  @ViewChildren('scrollLink')
  private scrollLinks;

  ingredientChoicesTypeEnum = IngredientChoicesType;
  headerWidth = 0;
  isTablet: boolean;
  canMoveToStepGroupPipe = new CanMoveToStepGroupPipe();
  canMoveToStepChoice = new CanMoveToStepChoicePipe();
  choicesService: EditingItemChoicesService;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(private viewportService: ViewportService) {}

  ngOnInit(): void {
    this.viewportService.viewport$.pipe(takeUntil(this.destroy$)).subscribe(viewport => {
      this.isTablet = viewport.isTablet;
    });
  }

  ngAfterViewInit(): void {
    this.loadComponent.emit({ scrollLinksWrapper: this.scrollLinksWrapper, scrollLinks: this.scrollLinks });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadComponent.emit({ scrollLinksWrapper: this.scrollLinksWrapper, scrollLinks: this.scrollLinks });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleCancel() {
    this.cancelBtnClick.emit();
  }

  selectChoice(choice: IngredientChoice, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (
      (this.orderableItem.choiceGroups && this.orderableItem.choiceGroups.length) ||
      this.ingredientChoicesType !== this.ingredientChoicesTypeEnum.Steps ||
      this.canMoveToStepChoice.transform(choice, this.choices, this.visibleChoice, this.item)
    ) {
      this.onSelectChoice.emit(choice);
    }
  }

  onChoiceGroupChange(choiceGroup: IngredientChoiceGroup, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (
      this.ingredientChoicesType !== this.ingredientChoicesTypeEnum.Steps ||
      this.canMoveToStepGroupPipe.transform(choiceGroup, this.item, this.selectedChoiceGroup, this.choiceGroups)
    ) {
      this.choiceGroupChange.emit(choiceGroup);
    }
  }
}
